import {CHANGE_PAGE} from '../../actionTypes';

export function set_page(page) {
	return {
		type: CHANGE_PAGE,
		page
	};
}